'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useRef, } from 'react';
import { useToggleButton, useFocusRing, useHover, mergeProps, } from 'react-aria';
import { useToggleState } from 'react-stately';
import { Icon } from '../Icon/Icon';
import { cx } from '../utils/cx';
import styles from './Chip.module.css';
const Ctx = createContext(null);
export function ChipGroup(props) {
    const ctx = props.mode === 'multi'
        ? { mode: 'multi', value: props.value, onChange: props.onChange }
        : {
            mode: 'single',
            value: props.value,
            onChange: props.onChange,
            allowDeselect: props.allowDeselect ?? true,
        };
    return (_jsx("div", { role: "group", "aria-label": props.label, className: cx(styles.group, props.className), children: _jsx(Ctx.Provider, { value: ctx, children: props.children }) }));
}
export function Chip({ value, children, count, iconName, className }) {
    const ctx = useContext(Ctx);
    if (ctx === null) {
        throw new Error('Chip must be rendered inside a ChipGroup.');
    }
    const isSelected = ctx.mode === 'single' ? ctx.value === value : ctx.value.includes(value);
    const handleChange = (nextSelected) => {
        if (ctx.mode === 'single') {
            if (nextSelected) {
                ctx.onChange(value);
            }
            else if (ctx.allowDeselect) {
                ctx.onChange(null);
            }
            return;
        }
        if (nextSelected) {
            ctx.onChange([...ctx.value, value]);
        }
        else {
            ctx.onChange(ctx.value.filter((v) => v !== value));
        }
    };
    const ref = useRef(null);
    const state = useToggleState({ isSelected, onChange: handleChange });
    const { buttonProps } = useToggleButton({ isSelected, onChange: handleChange }, state, ref);
    const { focusProps, isFocusVisible } = useFocusRing();
    const { hoverProps, isHovered } = useHover({});
    return (_jsxs("button", { ...mergeProps(buttonProps, focusProps, hoverProps), ref: ref, style: { font: 'var(--type-body)' }, className: cx(styles.chip, isSelected && styles.selected, isHovered && !isSelected && styles.hovered, isFocusVisible && styles.focusVisible, className), children: [iconName ? (_jsx("span", { className: styles.iconSlot, "aria-hidden": "true", children: _jsx(Icon, { name: iconName }) })) : null, _jsx("span", { className: styles.label, children: children }), typeof count === 'number' ? (_jsx("span", { className: styles.count, style: { font: 'var(--type-label-sm)' }, children: count })) : null] }));
}
//# sourceMappingURL=Chip.js.map